var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBurger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#646D7C",
    d: "M0 0h20v1H0zm0 4h15.454v1H0zm0 4h20v1H0zm0 4h10.909v1H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBurger);
export default __webpack_public_path__ + "static/media/ic-burger.2cb657f7bb11798da5dabc11e7931afb.svg";
export { ForwardRef as ReactComponent };